export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state')

        if (serializedState === null) {
            return undefined
        }

        return JSON.parse(serializedState)
    } catch (error) {
        return undefined
    }
}

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state)
        localStorage.setItem('state', serializedState)
    } catch (error) {
        //ingnore write errors.
    }
}

export const cleanStore = () => {
    const referral = JSON.parse(localStorage.getItem('state')).callbackReducer.referral
    localStorage.clear();
    let redirect = 'https://www.credility.com'
    switch (referral) {
        case 'Iaja':
            redirect = 'https://iaja.com.ar/'
            break;
        case 'Redcloud':
            redirect = 'https://redcloudtechnology.com.ar/'
            break;
        case 'Columbia':
            redirect = 'https://secure.bancocolumbia.com.ar/web/'
            break;
        case 'Interfinanzas':
            redirect = 'https://https://www.bancointerfinanzas.com.ar//'
            break;   
        case 'Bst':
            redirect = 'https://www.bst.com.ar/'
            break;   
        case 'Ciudad':
            redirect = 'https://www.bancociudad.com.ar/'
            break;
        case 'Cmf':
            redirect = 'https://www.bancocmf.com.ar/'
            break;
        case 'Came':
            redirect = 'http://www.redcame.org.ar/'
            break;    
        case 'Bacs':
            redirect = 'https://www.bacs.com.ar/'
            break;  
        case 'Mills':
            redirect = 'https://www.millscapitalgroup.com/'
            break;  
        case 'Acindarpymes':
            redirect = 'https://www.acindarpymes.com.ar/'
            break;     
        case 'Mariva':
            redirect = 'https://www.credility.com/iaja/'
            break;
        case 'Bvds':
            redirect = 'https://www.credility.com/'
            break;    
        case 'Directo':
            redirect = 'https://www.directo.com.ar/'
            break;    
        case 'Comafi':
            redirect = 'https://www.comafi.com.ar/'
            break;
        case 'Celesol':
            redirect = 'https://www.credility.com/'
            break;      
        case 'Agilis':
            redirect = 'https://www.agilis.com.ar/'
            break;
        case 'Bice':
            redirect = 'https://www.bice.com.ar/'
            break;       
        default:
            break;
    }
    window.location.replace(redirect);

}



// WEBPACK FOOTER //
// ./src/localStore.js